import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  Typography,
  CssBaseline,
  Container,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Grid,
  Paper,
} from "@material-ui/core";
import PaisContext from "../../../context/pais/paisContext";
import ProvinciaContext from "../../../context/provincia/provinciaContext";
import LocalidadContext from "../../../context/localidad/localidadContext";
import ValidationsContext from "../../../context/validations/validationsContext";

import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

import InputMask from "react-input-mask";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { MdDelete } from "react-icons/md";
import Help from "../../Dialog/HelpPopover";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";

const useStyles = makeStyles((theme) => ({
  step: {
    width: "10%",
    display: "flex",
    flexDirection: "row",
    padding: "0px 1em 0px 0px",
    marginLeft: "65%",
    fontSize: "30px",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  help: {
    height: "2em",
    width: "2em",
    position: "absolute",
    right: "1em",
    /*         marginTop:"10px"
     */
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    display: "flex",
    height: "100%",
    flexDirection: "row-reverse",
    position: "relative",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formInputs: {
    width: "73.333333%",
    height: "100%",
  },
  formTelefonos: {
    width: "33.33333333%",
    height: "100%",
    marginLeft: "1.2em",
    padding: "0em 1em 1em 1em",
  },
  telList: {
    height: "40%",
    maxHeight: "30vh",
    width: "100%",
    marginRight: "0px",
    marginLeft: "1em",
    paddingBottom: "1em",
    paddingRight: "0px",
    paddingTop: "0px",
  },
  telListPaper: {
    width: "100%",
    height: "18%",
    maxHeight: "100%",
    marginRight: "0px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
}));

export default function Formulario({
  grabarCliente,
  errorCliente,
  handleNext,
  handleBack,
  cliente,
}) {
  const classes = useStyles();
  const validationsContext = useContext(ValidationsContext);
  const {
    validateForm,
    validateUsername,
    validateeMail,
    validateDirecciones,
    validateCuit,
    validatePassword,
    validateCodigoArea,
    validateNumeroTelefono,
    validateRepeatPassword,
  } = validationsContext;
  const [tempTelList, setTempTelList] = useState(
    cliente.telefono ? cliente.telefono : []
  );
  const [tempTel, setTempTel] = useState({
    codigoPais: "+54",
    numeroTelefono: "",
    numeroTelefonoFijo: "",
    codigoArea: "",
  });
  const [state, setState] = useState({
    cuit: "",
    razonSocial: "",
    direccion: "",
  });
  const [dis, setDis] = useState(true);
  const [telElegido, setTelElegido] = useState("");
  ////pasos step
  function getSteps() {
    return [" ", " ", " ", " "];
  }
  const steps = getSteps();
  ///fin step
  const elegirTipoTel = (opcion) => {
    if (opcion === "celular") {
      tempTel.numeroTelefonoFijo = " ";
      return (tempTel.codigoPais = "+549");
    } else if (opcion === "telefono") {
      tempTel.numeroTelefono = "";
      return (tempTel.codigoPais = "+54");
    } else {
      tempTel.numeroTelefono = "";
      tempTel.numeroTelefonoFijo = " ";
    }
  };
  const pushTelList = () => {
    let noRepetido = true;
    const codPais = tempTel.codigoPais;
    const codigoArea = tempTel.codigoArea.slice(1, 6);
    const numero = tempTel.numeroTelefono.slice(2, 10)
      ? tempTel.numeroTelefono.slice(2, 10)
      : tempTel.numeroTelefonoFijo;
    let numeroCompararLista;
    let numeroInput = codigoArea + numero;
    tempTelList.map((t) => {
      numeroCompararLista = t.codigoArea + t.numeroTelefono;
      if (numeroCompararLista === numeroInput) {
        noRepetido = false;
      }
    });
    if (noRepetido) {
      tempTelList.push({
        codigoPais: codPais,
        numeroTelefono: numero,
        codigoArea: codigoArea,
      });
    }
    setTempTel({
      codigoPais: "",
      numeroTelefono: "",
      numeroTelefonoFijo: "",
      codigoArea: "",
    });
    aceptarBoton();
    elegirTipoTel(" ");
  };
  function removeItemFromArr(arr, item, i) {
    const a = arr;
    setTempTelList(
      a.filter(function (e, index) {
        return index !== i;
      })
    );
  }
  function ListaTelefonica({ lista }) {
    return (
      <List dense={true}>
        {" "}
        {lista.map((x, index) => {
          return (
            <ListItem>
              {x.codigoPais === "+549" ? (
                <>
                  <ListItemText
                    primary={x.codigoArea + "- 15" + x.numeroTelefono}
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => removeItemFromArr(tempTelList, x, index)}
                    >
                      <MdDelete />
                    </IconButton>
                  </ListItemSecondaryAction>
                </>
              ) : (
                <>
                  <ListItemText
                    primary={+x.codigoArea + " - " + x.numeroTelefono}
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => removeItemFromArr(tempTelList, x, index)}
                    >
                      <MdDelete />
                    </IconButton>
                  </ListItemSecondaryAction>
                </>
              )}
            </ListItem>
          );
        })}
      </List>
    );
  }
  const isFormIncomplete = () => {
    return tempTelList.length === 0;
  };
  const isTelIncomplete = () => {
    return (
      tempTel.codigoArea.trim() === "" ||
      (tempTel.numeroTelefono.trim() === "" &&
        tempTel.numeroTelefonoFijo.trim() === "")
    );
  };

  const onChangeTel = (e) => {
    setTempTel({
      ...tempTel,
      [e.target.name]: e.target.value,
    });
  };
  const onChange = (e) => {
    // cargo el preview
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const cancelarBoton = () => {
    setDis(false);
  };
  const aceptarBoton = () => {
    setDis(true);
  };
  // Cuando el usuario guardar o actualizar la localidad
  const onSubmit = (e) => {
    e.preventDefault();
    // Validar que no haya campos vacios
    if (isFormIncomplete()) {
      errorCliente("Todos los campos con * son obligatorios", "error");
    }
  };
  const next = (tempTelList) => {
    if (tempTelList) {
      state.telefono = tempTelList;
      handleNext(state);
    }
  };
  return (
    <div style={{ width: "550px" }}>
      <Stepper
        nonLinear
        activeStep={3}
        className={classes.step}
        style={{ backgroundColor: "#fafafa" }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton style={{ cursor: "default" }}>{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <CssBaseline />
      <div
        className={classes.form}
        noValidate
        onSubmit={onSubmit}
        autoComplete="off"
      >
        <Grid container justify="space-around">
          <Grid container direction="row" alignItems="center" spacing={1}>
            <Grid item xs={6} md={6} lg={6}>
              <Select
                variant="outlined"
                required
                fullWidth
                labelId="tel"
                id="tel"
                name="tel"
                value={
                  tempTel.codigoPais === "+549"
                    ? "Celular"
                    : tempTel.codigoPais === "+54"
                    ? "Fijo"
                    : " "
                }
                onChange={onChange}
                label="Tipo"
              >
                <MenuItem
                  value="Celular"
                  onClick={() => elegirTipoTel("celular")}
                >
                  Celular
                </MenuItem>
                <MenuItem
                  value="Fijo"
                  onClick={() => elegirTipoTel("telefono")}
                >
                  Fijo
                </MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <TextField
                margin="normal"
                id="sandard-required"
                label="Cod. Pais"
                fullWidth
                value={tempTel.codigoPais === "+549" ? "+549" : "+54"}
                variant="outlined"
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={8} md={3} lg={3}>
              <InputMask
                maskChar=""
                mask="\09999"
                value={tempTel.codigoArea}
                onChange={onChangeTel}
              >
                {() => (
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="codigoArea"
                    label={"Codigo Área"}
                    id="codigoArea"
                    margin="normal"
                    type="text"
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={8} md={6} lg={6}>
              {tempTel.codigoPais === "+549" ? (
                <InputMask
                  maskChar=""
                  mask="1\599999999"
                  value={tempTel.numeroTelefono}
                  onChange={onChangeTel}
                >
                  {() => (
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="numeroTelefono"
                      label={"Número"}
                      id="numeroTelefono"
                      margin="normal"
                      type="text"
                    />
                  )}
                </InputMask>
              ) : (
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="numeroTelefonoFijo"
                  label={"Número"}
                  id="numeroTelefonoFijo"
                  margin="normal"
                  type="text"
                  value={tempTel.numeroTelefonoFijo}
                  onChange={onChangeTel}
                />
              )}
            </Grid>
            <Grid item xs={8} md={2} lg={2}>
              {!isTelIncomplete() ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => pushTelList()}
                  style={{ color: "#0B3845" }}
                >
                  Agregar
                </Button>
              ) : (
                <Button variant="outlined" onClick={() => cancelarBoton()}>
                  Agregar
                </Button>
              )}
            </Grid>
          </Grid>
          {dis ? (
            <Grid item xs={12} md={12} lg={12}>
              <p style={{ color: "red" }}> </p>
            </Grid>
          ) : (
            <Grid item xs={12} md={12} lg={12}>
              <p style={{ color: "red" }}>El numero ingresado no es correcto</p>
            </Grid>
          )}
          <Grid item xs={1} md={1} lg={1}>
            <div className={classes.help}>
              <Help
                info={
                  "En caso de emergencia le será notificado a estos teléfonos"
                }
              />
            </div>
          </Grid>
          <Paper className={classes.telListPaper}>
            {tempTelList.length !== 0 ? (
              <>
                <br></br>
                <ListaTelefonica lista={tempTelList} />
              </>
            ) : (
              <p style={{ padding: "20px" }}>
                *Agregue al menos un teléfono a la lista
              </p>
            )}
          </Paper>
          <Grid item xs={6}>
            <Grid item xs={10} md={10} lg={10}>
              <Button
                mx="auto"
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => handleBack()}
                style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
              >
                Volver
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container justify="flex-end">
              <Grid item xs={10} md={10} lg={10}>
                {isFormIncomplete() ? (
                  <Button
                    mx="auto"
                    type="submit"
                    disabled
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Siguiente
                  </Button>
                ) : (
                  <Button
                    mx="auto"
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
                    onClick={() => next(tempTelList)}
                  >
                    Siguiente
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
